import sanityClient from 'picosanity';
import throwForFalsy from '../throwForFalsy';

type SanityClientConfig = {
  projectId: string;
  apiVersion?: string;
  dataset: string;
  useCdn: boolean;
};

export function getSanityClientConfig(): SanityClientConfig {
  return {
    projectId: throwForFalsy(process.env.NEXT_PUBLIC_SANITY_PROJECT_ID),
    dataset: throwForFalsy(process.env.NEXT_PUBLIC_SANITY_DATASET),
    useCdn: true,
  };
}

export function getSanityClient(opts: Partial<SanityClientConfig> = {}) {
  return sanityClient({
    ...getSanityClientConfig(),
    ...opts,
  });
}
